import { useRef } from 'react';
import * as THREE from 'three';

interface LightingProps {
  showHelpers?: boolean;
}

/**
 * Scene lighting component
 * Creates bright, clear aviation-style lighting
 */
export function Lighting({ showHelpers = false }: LightingProps): React.JSX.Element {
  const directionalLightRef = useRef<THREE.DirectionalLight>(null);

  return (
    <>
      {/* Ambient light for overall scene brightness */}
      <ambientLight intensity={0.6} color="#b0e0e6" />

      {/* Main directional light (sun) */}
      <directionalLight
        ref={directionalLightRef}
        position={[50, 80, 30]}
        intensity={1.5}
        color="#fffaf0"
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={200}
        shadow-camera-left={-50}
        shadow-camera-right={50}
        shadow-camera-top={50}
        shadow-camera-bottom={-50}
        shadow-bias={-0.0001}
      />

      {/* Secondary fill light */}
      <directionalLight
        position={[-30, 40, -20]}
        intensity={0.4}
        color="#87ceeb"
      />

      {/* Hemisphere light for sky/ground color transition */}
      <hemisphereLight
        color="#87ceeb"
        groundColor="#4ade80"
        intensity={0.5}
      />

      {/* Debug helpers */}
      {showHelpers && directionalLightRef.current && (
        <primitive
          object={new THREE.DirectionalLightHelper(directionalLightRef.current, 5)}
        />
      )}
    </>
  );
}
